module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"head":"Our customers rate us ","rating":"{0} out of 5 stars!","readAll":"Read all reviews.","smallPrint":"Independent Service Rating based on ","subHead":"That’s right, {0} of our customers reviewed us on on Feefo","verified":" verified reviews."}}')
  delete Component.options._Ctor
}
